/**
 * Хранение выбранного проекта между сессиями.
 * Вынесено из ActiveProjectContext, чтобы AuthContext мог сбрасывать выбор
 * при входе/выходе без циклического импорта контекстов.
 */
export const ACTIVE_PROJECT_STORAGE_KEY = 'dtcore.active_project_db_name';

export const readStoredActiveProject = () => {
  try {
    return localStorage.getItem(ACTIVE_PROJECT_STORAGE_KEY) || '';
  } catch {
    return '';
  }
};

export const writeStoredActiveProject = (dbName) => {
  try {
    if (dbName) localStorage.setItem(ACTIVE_PROJECT_STORAGE_KEY, dbName);
    else localStorage.removeItem(ACTIVE_PROJECT_STORAGE_KEY);
  } catch {
    // ignore storage errors
  }
};

export const clearStoredActiveProject = () => writeStoredActiveProject('');
